import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
const AccountMappingForm = (props) => {
  const frmRef = useRef({});
  const productRef = useRef({});

  const [accountHead, setAccountHead] = useState(null);
  const [accountGroupId, setAccountGroupId] = useState("");
  const [accountGroupData, setaccountGroupData] = useState([]);
  const [accountGroupFiliterData, setaccountGroupFiliterData] = useState([]);

  const [accountSubGroupId, setAccountSubGroupId] = useState("");
  const [accountSubGroupData, setaccountSubGroupData] = useState([]);
  const [accountSubGroupFiliterData, setaccountSubGroupFiliterData] = useState(
    []
  );

  const { sendRequest: getAccountGroup } = useHttp();

  useEffect(() => {
    getAccountGroup(
      {
        url: `/api/accountGroup?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setaccountGroupData(res);
        }
      }
    );
  }, [getAccountGroup]);

  const { sendRequest: getAccountSubGroup } = useHttp();

  useEffect(() => {
    getAccountSubGroup(
      {
        url: `/api/accountSubGroup?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setaccountSubGroupData(res);
        }
      }
    );
  }, [getAccountSubGroup]);

  const { sendRequest: postProcurementReciept } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const data = {
      accountSubGroupId: accountSubGroupId,
      accountName: frmRef.current.accountName.value.trim(),
      accountCode: frmRef.current.accountCode.value.trim(),
      status: 1,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
    };

    postProcurementReciept(
      {
        url: "/api/accountDetail/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        var error = false;
        var msg = `Account subgroup detail ${
          props.update ? "updated" : "added"
        } `;
        if (data == "Account subgroup name/code already present") {
          msg = `Account subgroup name/code already present`;
          error = true;
        }
        toast.success(msg);
        props.addForm(error);
      }
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Account Detail</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Group Type</label>

                        <select
                          id="emp_id"
                          required
                          className="form-control"
                          ref={(el) => (frmRef.current["accountHead"] = el)}
                          value={accountHead}
                          onChange={(e) => {
                            var id = e.target.value;
                            setAccountHead(id);
                            var accountGrouplist = accountGroupData.filter(
                              (item) => item.accountHead == id
                            );

                            setaccountGroupFiliterData(accountGrouplist);
                          }}
                        >
                          <option selected value="">
                            --Select Group Type--
                          </option>

                          <option> Asset</option>
                          <option>Expenses</option>
                          <option>Income </option>
                          <option>Liability</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Account Group </label>

                        <select
                          id="emp_id"
                          required
                          className="form-control"
                          ref={(el) => (frmRef.current["accountHead"] = el)}
                          value={accountGroupId}
                          onChange={(e) => {
                            setAccountGroupId(e.target.value);
                            var id = e.target.value;
                            var accountSubGrouplist =
                              accountSubGroupData.filter(
                                (item) => item.accountGroupId == id
                              );

                            setaccountSubGroupFiliterData(accountSubGrouplist);
                          }}
                        >
                          <option selected value="">
                            --Select Group --
                          </option>

                          {accountGroupFiliterData &&
                            accountGroupFiliterData.map((x) => (
                              <option
                                key={x.accountGroupId}
                                accountGroup-id={x.accountGroupId}
                                value={x.accountGroupId}
                              >
                                {x.accountGroupName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Account Subgroup </label>

                        <select
                          id="emp_id"
                          required
                          className="form-control"
                          ref={(el) =>
                            (frmRef.current["accountSubGroupId"] = el)
                          }
                          value={accountSubGroupId}
                          onChange={(e) => {
                            setAccountSubGroupId(e.target.value);
                          }}
                        >
                          <option selected value="">
                            --Select Group --
                          </option>

                          {accountSubGroupFiliterData &&
                            accountSubGroupFiliterData.map((x) => (
                              <option
                                key={x.accountSubGroupId}
                                accountSubGroup-id={x.accountSubGroupId}
                                value={x.accountSubGroupId}
                              >
                                {x.accountSubGroupName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Account Name </label>

                        <input
                          type={"text"}
                          id={"AccountName"}
                          required
                          ref={(el) => (frmRef.current["accountName"] = el)}
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Account Code </label>

                        <input
                          type={"text"}
                          id={"accountCode"}
                          required
                          ref={(el) => (frmRef.current["accountCode"] = el)}
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group"></div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group"></div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group"></div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group"></div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button className="btn  btn-primary mx-2 my-2" type="submit">
                        Add
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default AccountMappingForm;
